import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/LoginForm';
import { useAuthViewModel } from '../viewmodels/AuthViewModel';
import { LoginFormData } from '../models/AuthModels';
import Logger from '../utils/logger';
import { isMobileDevice } from '../utils/deviceDetection';

// 로그인 페이지 컴포넌트
const Login: React.FC = () => {
  const navigate = useNavigate();

  // AuthViewModel 훅 사용
  const {
    login,
    isLoggedIn,
    isLoading,
    error,
    clearError,
  } = useAuthViewModel();

  // 이미 로그인된 경우 대시보드로 리다이렉트
  useEffect(() => {
    console.log('Login 컴포넌트 - isLoggedIn 상태 변경:', isLoggedIn);
    if (isLoggedIn) {
      console.log('로그인 상태 확인됨 - 대시보드로 리다이렉트');
      // replace: true로 브라우저 히스토리에서 로그인 페이지를 제거
      const target = isMobileDevice() ? '/mobile/dashboard' : '/dashboard';
      navigate(target, { replace: true });
    } else {
      console.log('로그인되지 않은 상태 - 로그인 폼 표시');
    }
  }, [isLoggedIn, navigate]);

  // 컴포넌트 마운트 시 저장된 로그 확인
  useEffect(() => {
    const logs = Logger.getLogs();
    if (logs.length > 0) {
      console.log('📋 이전 로그인 시도 로그:', logs.length + '개');
      Logger.printLogs();
    }
  }, []);

  // 로그인 폼 제출 처리
  const handleLoginSubmit = async (formData: LoginFormData): Promise<void> => {
    console.log('로그인 폼 제출 시작:', formData);
    const success = await login(formData);
    console.log('로그인 결과:', success);

    if (success) {
      console.log('로그인 성공 - 대시보드로 이동');
      navigate(isMobileDevice() ? '/mobile/dashboard' : '/dashboard', { replace: true });
    } else {
      console.log('로그인 실패 - 에러 메시지 표시');
    }
    // 실패 시에는 에러 메시지가 AuthViewModel에서 자동으로 설정됨
  };

  // 이미 로그인된 상태라면 로딩 표시 (리다이렉트 대기)
  if (isLoggedIn) {
    return null; // 또는 로딩 스피너
  }

  return (
    <LoginForm
      onSubmit={handleLoginSubmit}
      isLoading={isLoading}
      error={error}
      onClearError={clearError}
    />
  );
};

export default Login; 